import RichTextComposer from './RichTextComposer';

export default RichTextComposer;
